// vuetify.options.js
export default {
  // breakpoint: {
  //   thresholds: {
  //     xs: 340,
  //     sm: 540,
  //     md: 800,
  //     lg: 1280,
  //   },
  // },
  icons: {
    iconfont: 'mdiSvg',
  },
  // lang: {},
  // rtl: true,
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1a1a1a',
      },
      dark: {
        primary: '#1a1a1a',
      },
    },
  },
};
